import ChartTableContent from './chart_table_content.js';
import RadioBtnGroup from 'trunks/vue/admin/components/report/radio_btn_group.js';
import ReportChart from './report_chart.js';

var barOptions, pieOptions, radio_chart_table;

barOptions = {
  legend: {
    display: false
  },
  layout: {
    padding: {
      top: 20
    }
  },
  tooltips: {
    enabled: false
  },
  scales: {
    yAxes: [
      {
        display: false,
        ticks: {
          beginAtZero: true
        }
      }
    ],
    xAxes: [
      {
        barThickness: 20,
        gridLines: {
          display: false
        }
      }
    ]
  },
  hover: {
    animationDuration: 0
  }
};

pieOptions = {
  legend: {
    display: false
  },
  layout: {
    padding: {
      top: 26,
      bottom: 26
    }
  },
  scales: {
    yAxes: [
      {
        display: false
      }
    ],
    xAxes: [
      {
        display: false
      }
    ]
  },
  tooltips: {
    enabled: false
  },
  hover: {
    animationDuration: 0
  }
};

export default radio_chart_table = Vue.extend({
  components: {
    'chart-table': ChartTableContent,
    'radio-btn-group': RadioBtnGroup,
    'report-chart': ReportChart
  },

  props: {
    field: {
      type: Object,
      default: null
    }
  },

  data: function() {
    return {
      btn_group_options: ['bar', 'pie'],
      chartType: 'bar',
      sortType: 'normal',
      chartOptions: {}
    };
  },

  template: `
    <chart-table :title='field.title' :fieldType='field.type' @toggleChangeSort="changeSort">
      <template slot="chart-data-counts">
        <div class="text-small ml-6 gray-text">{{ field.options.length }}条数据</div>
      </template>
      <template slot="chart-content">
        <div class="chart-content">
          <radio-btn-group :btn_group_options='btn_group_options'
                           @setSelectedValue='setChartType'/>

          <div class="chart-show">
            <report-chart :chartData='chartData'
                          :chartType='chartType'
                          :chartOptions='chartOptions' />
          </div>
        </div>
      </template>
      <template slot="chart-data-table-tbody">
        <tr v-for="option in sortFieldOptions" :key='option.id'>
          <td>{{ option.value }}</td>
          <td>{{ option.selected_count }}</td>
          <td>{{ _getPercentage(option.selected_count) + '%' }}</td>
        </tr>
      </template>
    </chart-table>
  `,

  computed: {
    fieldOptions: function() {
      var option, options;

      option = _.clone(this.field.other_option);
      options = _.clone(this.field.options);
      if (option.name) {
        option.value = option.name;
        options.push(option);
      }
      return options;
    },

    sortFieldOptions: function() {
      switch (this.sortType) {
        case 'asc':
          return _.sortBy(this.fieldOptions, function(item) {
            return item.selected_count;
          });
        case 'desc':
          return _.sortBy(this.fieldOptions, function(item) {
            return -item.selected_count;
          });
        default:
          return this.fieldOptions;
      }
    },

    chartData: function() {
      return _.reduce(this.sortFieldOptions, (memo, option) => {
        memo.labels.push(option.value);
        memo.data.push(this._getPercentage(option.selected_count));
        return memo;
      }, {
        labels: [],
        data: []
      });
    }
  },

  created: function() {
    return this.setChartOptions();
  },

  methods: {
    setChartOptions: function() {
      if (this.chartType === 'bar') {
        return this.chartOptions = barOptions;
      } else {
        return this.chartOptions = pieOptions;
      }
    },

    setChartType: function(option) {
      this.chartType = option;
      return this.setChartOptions();
    },

    changeSort: function() {
      return this.sortType = (function() {
        switch (this.sortType) {
          case 'asc':
            return 'desc';
          case 'desc':
            return 'normal';
          case 'normal':
            return 'asc';
        }
      }).call(this);
    },

    _getPercentage: function(selected_count) {
      return Number((selected_count / this.field.total_selected_count) * 100).toFixed(1);
    }
  }
});
